export function editorLink(href,current){
 const target=new URL(href,current),entry=new URL(current);
 const market=entry.pathname.match(/^\/(?:([a-z]{2}(?:-[a-z]{2})?)\/)?products\//i);
 if(market)target.pathname=market[1]?'/'+market[1]+'/':'/';
 // Preserve market path from Liquid; keep only known campaign/currency parameters outside the hash.
 const keys=new Set([...entry.searchParams.keys()].filter(key=>key==='currency'||key.startsWith('utm_')||['gclid','gbraid','wbraid'].includes(key)));
 for(const key of keys)target.searchParams.delete(key);
 for(const [key,value] of entry.searchParams){
  if(keys.has(key))target.searchParams.append(key,value);
 }
 return target.pathname+target.search+target.hash;
}
export function designsLink(href,current,model=''){
 const target=new URL(editorLink(href,current),current);
 target.hash=model?'modelo/'+encodeURIComponent(model):'coleccion/todos';
 return target.pathname+target.search+target.hash;
}
export function shoppingSource(current){const p=new URL(current).searchParams;return p.get('utm_medium')==='product_sync'||p.has('gclid')||p.has('gbraid')||p.has('wbraid')?'google_shopping':'product_page';}
export function trackClick(w,d,model,event='pdp_cta_click'){
 try{
  if(w.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;
  const internal=/(?:^|;\s*)pevita_internal=1(?:;|$)/.test(d.cookie||'');
  w.dataLayer=w.dataLayer||[];w.gtag=w.gtag||function(){w.dataLayer.push(arguments);};
  if(!d.querySelector('script[src*="googletagmanager.com/gtag/js"]')){
   w.gtag('js',new Date());w.gtag('config','G-FFK0S286Z3',{send_page_view:false});
   const s=d.createElement('script');s.async=true;s.src='https://www.googletagmanager.com/gtag/js?id=G-FFK0S286Z3';d.head.append(s);
  }
  w.gtag('event',event,{model,source:shoppingSource(w.location.href),send_to:'G-FFK0S286Z3',transport_type:'beacon',...(internal?{traffic_type:'internal'}:{})});
 }catch{}
}
export function mount(w,d){
 const page=d.querySelector('[data-shopping-pdp]');if(!page)return;
 const primary=page.querySelector('.shopping-primary'),sticky=page.querySelector('.shopping-sticky');
 for(const link of page.querySelectorAll('[data-pdp-cta]')){link.href=editorLink(link.href,w.location.href);link.addEventListener('click',()=>trackClick(w,d,page.dataset.model));}
 for(const link of page.querySelectorAll('[data-pdp-designs]')){link.href=designsLink(link.href,w.location.href,page.dataset.model);link.addEventListener('click',()=>trackClick(w,d,page.dataset.model,'pdp_designs_click'));}
 const update=()=>{
  // Stay above the Shopify consent banner without hiding it or changing consent.
  let offset=0;
  for(const banner of d.querySelectorAll('#shopify-pc__banner,.shopify-pc__banner__dialog')){const b=banner.getBoundingClientRect();if(b.width&&b.height&&b.bottom>=w.innerHeight-2&&b.top<w.innerHeight)offset=Math.max(offset,w.innerHeight-b.top);}
  const primaryBottom=page.querySelector('.shopping-summary [data-pdp-designs]').getBoundingClientRect().bottom;
  sticky.hidden=!(w.matchMedia('(max-width:760px)').matches&&(primaryBottom<0||(offset>0&&primaryBottom>w.innerHeight-offset)));
  sticky.style.setProperty('--shopping-cookie-offset',offset+'px');
 };
 let scheduled=false;const schedule=()=>{if(!scheduled){scheduled=true;w.requestAnimationFrame(()=>{scheduled=false;update();});}};
 w.addEventListener('scroll',schedule,{passive:true});w.addEventListener('resize',schedule);d.addEventListener('visitorConsentCollected',schedule);
 new MutationObserver(schedule).observe(d.body,{childList:true,subtree:true});update();
}
if(typeof window!=='undefined')mount(window,document);
